<h2 mat-dialog-title class="dialog-title">
  <div>
    <div class="eyebrow">Calendar</div>
    <div class="title">Edit entry</div>
  </div>
</h2>

<div mat-dialog-content class="dialog-body">
  <div class="card">
    <div class="card-header">
      <div>
        <div class="eyebrow">Summary</div>
        <div class="card-title">What’s happening?</div>
      </div>
      <mat-checkbox [(ngModel)]="entry.pinned">Pin to top</mat-checkbox>
    </div>
    <div class="grid two-col">
      <mat-form-field appearance="outline">
        <mat-label>Title</mat-label>
        <input matInput [(ngModel)]="entry.title" placeholder="Pickup, call, onsite..." />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Category</mat-label>
        <input matInput [(ngModel)]="entry.category" placeholder="Pickup, Call, Onsite" />
      </mat-form-field>
    </div>
    <mat-form-field appearance="outline" class="full-span">
      <mat-label>Sub text</mat-label>
      <input matInput [(ngModel)]="entry.subtitle" placeholder="Short supporting line" />
    </mat-form-field>
    <div class="grid two-col">
      <mat-form-field appearance="outline">
        <mat-label>Date</mat-label>
        <input matInput type="date" [(ngModel)]="scheduledAtInput" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select [(value)]="entry.status">
          <mat-option *ngFor="let status of (CalendarEntryStatus | keyvalue)" [value]="status.value">
            {{ status.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <div>
        <div class="eyebrow">Details</div>
        <div class="card-title">Add context</div>
      </div>
    </div>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Description</mat-label>
      <textarea matInput rows="4" [(ngModel)]="entry.description" placeholder="Notes, instructions, contacts"></textarea>
    </mat-form-field>
  </div>
</div>

<div mat-dialog-actions align="end" class="dialog-actions">
  <button
    mat-stroked-button
    color="warn"
    type="button"
    class="delete-button"
    *ngIf="!isNew"
    (dblclick)="deleteEntry()"
  >
    Delete (double-click)
  </button>
  <span class="dialog-actions__spacer"></span>
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="save()">Save</button>
</div>
